(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["saidwhat-cinematic-hero"] && !Shopify.designMode) return;
  try {
    
(() => {
  const root = document.querySelector('[data-sw-cine]');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fine = matchMedia('(pointer:fine)').matches;
  const mobile = matchMedia('(max-width: 749px)').matches;
  const title = root.querySelector('[data-sw-cine-title]');
  const lines = title ? title.querySelectorAll('span') : [];
  const floats = root.querySelectorAll('[data-sw-float]');
  const progress = root.querySelector('[data-sw-progress]');
  const spot = root.querySelector('[data-sw-spot]');
  const clamp = (v,a,b) => Math.min(Math.max(v,a),b);
  let rootHeight = Math.max(1, root.offsetHeight - innerHeight);
  const recalc = () => { rootHeight = Math.max(1, root.offsetHeight - innerHeight); };
  addEventListener('resize', recalc, {passive:true});
  const update = () => {
    if (reduce) return;
    const r = root.getBoundingClientRect();
    const p = clamp((-r.top) / rootHeight, 0, 1);
    if (mobile) {
      if (lines[0]) lines[0].style.transform = `translate3d(${p*-1.2}vw,${p*-1}vh,0)`;
      if (lines[1]) lines[1].style.transform = `translate3d(${p*1.6}vw,0,0)`;
      if (lines[2]) lines[2].style.transform = `translate3d(${p*-1}vw,${p*1.2}vh,0)`;
      if (floats[0]) floats[0].style.transform = `translate3d(0,${p*22}px,0) rotate(${-4+p*1.2}deg)`;
      if (floats[1]) floats[1].style.transform = `translate3d(0,${p*-18}px,0) rotate(${5-p*1.2}deg)`;
      if (progress) progress.style.transform = `scaleX(${p})`;
      if (progress) { progress.style.width='100%'; progress.style.transformOrigin='left center'; }
      return;
    }
    if (lines[0]) lines[0].style.transform = `translate3d(${p*-5}vw,${p*-3}vh,0)`;
    if (lines[1]) lines[1].style.transform = `translate3d(${p*6}vw,0,0)`;
    if (lines[2]) lines[2].style.transform = `translate3d(${p*-4}vw,${p*4}vh,0)`;
    floats.forEach((el,i) => el.style.transform = `translate3d(0,${p*(i ? -60 : 80)}px,0) rotate(${i ? 5-p*3 : -4+p*3}deg)`);
    if (progress) progress.style.width = `${p*100}%`;
  };
  let ticking = false;
  addEventListener('scroll', () => { if (!ticking){ ticking=true; requestAnimationFrame(()=>{update();ticking=false;}); } }, {passive:true});
  update();
  if (fine && !mobile && !reduce) {
    root.addEventListener('pointermove', e => {
      const r = root.getBoundingClientRect();
      if (spot) { spot.style.left = `${e.clientX-r.left}px`; spot.style.top = `${e.clientY-r.top}px`; }
    }, {passive:true});
    root.querySelectorAll('[data-sw-magnetic]').forEach(btn => {
      btn.addEventListener('pointermove', e => { const r=btn.getBoundingClientRect(); btn.style.transform=`translate3d(${(e.clientX-r.left-r.width/2)*.12}px,${(e.clientY-r.top-r.height/2)*.16}px,0)`; }, {passive:true});
      btn.addEventListener('pointerleave', () => btn.style.transform='');
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["saidwhat-hero"] && !Shopify.designMode) return;
  try {
    
(() => {
  const section = document.currentScript?.closest('.shopify-section')?.querySelector('.sw-hero');
  if (!section) return;
  requestAnimationFrame(() => section.classList.add('is-visible'));
  const orbs = section.querySelectorAll('.sw-hero__orb');
  const onScroll = () => {
    const y = window.scrollY;
    orbs.forEach((orb, i) => orb.style.transform = `translate3d(${i ? y * .02 : -y * .015}px, ${y * (i ? .06 : .04)}px, 0)`);
  };
  onScroll();
  window.addEventListener('scroll', onScroll, {passive:true});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["saidwhat-interactive-grid"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!window.matchMedia('(pointer:fine)').matches) return;
  document.querySelectorAll('[data-sw-card]').forEach(card => {
    const img = card.querySelector('.sw-card__image');
    if (!img) return;
    const move = e => {
      const r = card.getBoundingClientRect();
      const x = (e.clientX-r.left)/r.width - .5;
      const y = (e.clientY-r.top)/r.height - .5;
      img.style.transform = `scale(1.08) translate3d(${x*-14}px,${y*-14}px,0) rotateX(${y*-4}deg) rotateY(${x*4}deg)`;
    };
    const leave = () => img.style.transform = 'scale(1.02)';
    card.addEventListener('pointermove', move);
    card.addEventListener('pointerleave', leave);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["saidwhat-luxury-rail"] && !Shopify.designMode) return;
  try {
    
(() => {
  const root=document.querySelector('[data-sw-rail]');if(!root||root.dataset.ready)return;root.dataset.ready='1';
  const track=root.querySelector('[data-sw-rail-track]');const bar=root.querySelector('[data-sw-rail-bar]');if(!track)return;
  let raf=0;
  const update=()=>{raf=0;const max=Math.max(1,track.scrollWidth-track.clientWidth);const p=track.scrollLeft/max;if(bar)bar.style.transform=`scaleX(${Math.max(.25,.25+p*.75)})`;};
  track.addEventListener('scroll',()=>{if(!raf)raf=requestAnimationFrame(update)},{passive:true});update();
  if(!matchMedia('(pointer:fine)').matches)return;let down=false,startX=0,startScroll=0,moved=false;
  track.addEventListener('pointerdown',e=>{down=true;moved=false;startX=e.clientX;startScroll=track.scrollLeft;track.classList.add('is-dragging');track.setPointerCapture(e.pointerId);});
  track.addEventListener('pointermove',e=>{if(!down)return;const dx=e.clientX-startX;if(Math.abs(dx)>5)moved=true;track.scrollLeft=startScroll-dx*1.25;});
  track.addEventListener('pointerup',e=>{down=false;track.classList.remove('is-dragging');try{track.releasePointerCapture(e.pointerId)}catch(err){}});
  track.addEventListener('click',e=>{if(moved)e.preventDefault();},true);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["saidwhat-manifesto-live"] && !Shopify.designMode) return;
  try {
    
(() => {
  const root=document.querySelector('[data-sw-manifesto]');
  if(!root || root.dataset.ready) return; root.dataset.ready='1';
  if(matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  const mobile=matchMedia('(max-width: 749px)').matches;
  const lines=root.querySelectorAll('[data-sw-copy] span');
  const image=root.querySelector('[data-sw-manifesto-image]');
  const clamp=(v,a,b)=>Math.min(Math.max(v,a),b);
  let range=Math.max(1,root.offsetHeight-innerHeight);
  const recalc=()=>{range=Math.max(1,root.offsetHeight-innerHeight)};
  addEventListener('resize',recalc,{passive:true});
  const update=()=>{const r=root.getBoundingClientRect();const p=clamp((-r.top)/range,0,1);if(mobile){if(lines[0])lines[0].style.transform=`translate3d(${p*3.2}vw,0,0)`;if(lines[1])lines[1].style.transform=`translate3d(${p*-3.2}vw,0,0)`;if(image)image.style.transform=`translate3d(-50%,calc(-50% + ${(p-.5)*24}px),0) rotate(${-2+p*1.4}deg) scale(${.98+p*.025})`;return;}if(lines[0])lines[0].style.transform=`translate3d(${p*11}vw,0,0)`;if(lines[1])lines[1].style.transform=`translate3d(${p*-11}vw,0,0)`;if(image)image.style.transform=`translate3d(-50%,calc(-50% + ${(p-.5)*70}px),0) rotate(${-2+p*4}deg) scale(${.92+p*.12})`;};
  let t=false;addEventListener('scroll',()=>{if(!t){t=true;requestAnimationFrame(()=>{update();t=false;});}},{passive:true});update();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["saidwhat-motion-stage"] && !Shopify.designMode) return;
  try {
    
(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const stages = document.querySelectorAll('[data-sw-motion-stage]');
  if (!stages.length || reduce) return;
  const clamp = (n,min,max)=>Math.min(Math.max(n,min),max);
  const update = () => {
    stages.forEach(stage => {
      const rect = stage.getBoundingClientRect();
      const span = Math.max(1, stage.offsetHeight - window.innerHeight);
      const p = clamp((-rect.top) / span, 0, 1);
      const title = stage.querySelector('[data-sw-title]');
      const a = stage.querySelector('.sw-motion-stage__orb--a');
      const b = stage.querySelector('.sw-motion-stage__orb--b');
      if (title) title.style.transform = `translate3d(${p*8}vw,${p*-8}vh,0) scale(${1 + p*.12}) rotate(${p*-2}deg)`;
      if (title) title.style.opacity = String(1 - p*.18);
      if (a) a.style.transform = `translate3d(${p*-18}vw,${p*10}vh,0) scale(${1+p*.25})`;
      if (b) b.style.transform = `translate3d(${p*16}vw,${p*-8}vh,0) scale(${1+p*.15})`;
    });
  };
  let ticking = false;
  const onScroll = () => { if (!ticking){requestAnimationFrame(()=>{update();ticking=false});ticking=true;} };
  update();
  addEventListener('scroll', onScroll, {passive:true});
  addEventListener('resize', update);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["saidwhat-product"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const boot = () => {
      document.querySelectorAll('[data-sw-product-section]').forEach((section) => {
        if (section.dataset.swReady === 'true') return;
        section.dataset.swReady = 'true';

        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const reveals = section.querySelectorAll('.sw-reveal');
        if (!reduced && 'IntersectionObserver' in window) {
          const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
                observer.unobserve(entry.target);
              }
            });
          }, { threshold: 0.12 });
          reveals.forEach((el) => observer.observe(el));
        } else {
          reveals.forEach((el) => el.classList.add('is-visible'));
        }

        const variantInput = section.querySelector('[data-sw-variant-input]');
        const price = section.querySelector('[data-sw-price]');
        const addPrice = section.querySelector('[data-sw-add-price]');
        section.querySelectorAll('[data-sw-variant-radio]').forEach((radio) => {
          radio.addEventListener('change', () => {
            if (!radio.checked) return;
            if (variantInput) variantInput.value = radio.value;
            if (price) price.textContent = radio.dataset.price || '';
            if (addPrice) addPrice.textContent = radio.dataset.price ? `— ${radio.dataset.price}` : '';
          });
        });

        const gallery = section.querySelector('[data-sw-gallery]');
        const count = section.querySelector('[data-sw-gallery-count]');
        const media = [...section.querySelectorAll('[data-sw-media]')];
        if (gallery && count && media.length) {
          const updateCount = () => {
            const center = gallery.getBoundingClientRect().left + gallery.clientWidth / 2;
            let nearest = 0;
            let distance = Infinity;
            media.forEach((item, index) => {
              const rect = item.getBoundingClientRect();
              const itemCenter = rect.left + rect.width / 2;
              const nextDistance = Math.abs(center - itemCenter);
              if (nextDistance < distance) {
                distance = nextDistance;
                nearest = index;
              }
            });
            const current = String(nearest + 1).padStart(2, '0');
            const total = String(media.length).padStart(2, '0');
            count.textContent = `${current} / ${total}`;
          };
          gallery.addEventListener('scroll', updateCount, { passive: true });
          updateCount();
        }
      });
    };

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();
})();
